import { callFunction } from "./firebase.js";

/**
 * 퍼널 — 날짜별 합계만 올린다. 개인 식별자는 보내지 않는다.
 *
 * 왜 필요했나: 지금 구조는 **모든 방문자가 로그인을 지나야** 토론을 시작할 수
 * 있다. 그런데 세고 있던 건 토론을 시작한 사람뿐이라, 「아무도 안 왔다」와
 * 「와서 로그인 벽에서 튕겼다」가 똑같이 0 으로 보였다.
 *
 * ★ 실패해도 **아무 일도 일어나지 않아야 한다.** 숫자 세다가 화면이 멈추면
 * 본말전도다. 전부 삼키고, 호출하는 쪽은 await 하지 않는다.
 *
 * 같은 지점은 한 번만 보낸다 — 화면이 리렌더될 때마다 세면 숫자가 부푼다.
 */
const sent = new Set();
let pending = new Set();
let timer = null;

function flush() {
  timer = null;
  const steps = [...pending];
  pending = new Set();
  if (!steps.length) return;
  callFunction("countFunnel", { steps }).catch(() => {});
}

/** @param {string} step funnel.js(서버)의 STEPS 중 하나 */
export function mark(step) {
  if (sent.has(step)) return;
  sent.add(step);
  pending.add(step);
  // 한 박자 모아서 한 번에 보낸다. 방문 한 번에 함수가 대여섯 번 깨는 걸 막는다.
  if (!timer) timer = setTimeout(flush, 1200);
}
